<template>
  <main>
    <section id="parallax" class="section--full section--banner" @mousemove="parallax">
      <video autoplay muted loop playsinline class="section__video">
        <source src="@/assets/video/csr.mp4" type="video/mp4">
      </video>
    </section>
    <section class="container container--short">
      <div class="container--white">
        <h2 class="heading-detail">MNC Peduli - CSR for Covid-19</h2>
        <div class="details">
          <!-- <div class="font-title">1. Penjelasan Aktivitas</div> -->
          <p class="description">
            Di usia yang ke 32 tahun,  MNC Peduli sebagai wadah CSR dari  MNC Group telah berpartisipasi dalam mendukung pemerintah untuk percepatan program vaksinasi Covid-19 dalam penanganan pandemi.
          </p>
          <br>
          <p class="description">
            Untuk menyambut dan menyongsong hari jadi MNC Group ke 32, MNC Peduli merencanakan rangkaian kegiatan penyelenggaraan vaksinasi di 32 titik lokasi yaitu daerah DKI Jakarta, Jawa Barat dan Jawa Tengah, dimana  telah menyuntikkan lebih dari 60.000 dosis 
          </p>
          <br>
          <p class="description">
            Selain inisiasi dari MNC Peduli, kegiatan vaksinasi Covid-19 ini juga merupakan kolaborasi dengan berbagai pihak, baik instansi pemerintah maupun swasta guna membentuk herd immunity di Indonesia.
          </p>
        </div>

        <div class="details">
          <img class="md-image" src="@/assets/images/csrbanner.jpg" alt="">
        </div>

        <div class="details">
          <div class="font-title">Rangkatian Aktivitas</div>
          <br>
          <p class="description">
            Kegiatan vaksinasi akan terus dilaksanakan agar dapat menyentuh masyarakat lainnya yang belum mendapatkan akses vaksinasi.
          </p>
          <ol class="details mg-left-35">
            <li class="description list-block">
              Vaksinasi di Jakarta Internasional Equestrian Park - Pulomas Bersama Enesis Group (23 Juni) – 14.000 dosis
            </li>
            <li class="description list-block">
              Vaksin bersama Dewan Pers di MNC Center (30 Juni – 3 Juli) – 1.521 dosis
            </li>
            <li class="description list-block">
              Vaksinasi MVN di Kedoya, Jakarta Barat (6-9 Juli) – 2.371 dosis
            </li>
            <li class="description list-block">
              Vaksinisasi Biro Surabaya (22 Juli) – 500 dosis
            </li>
            <li class="description list-block">
              Vaksinasi Bersama Kemenparekraf di MNC Center Kebon Sirih (23-27 Juli) – 2.252 dosis
            </li>
            <li class="description list-block">
              Vaksin bersama Kemenparekraf di MNC Studios (23-27 Juli) – 2.768 dosis
            </li>
            <li class="description list-block">
              Vaksin dosis ke 2 di Jakarta Internasional Equestrian Park – Pulomas Bersama Enesis Group (26 Jul-9 Agustus) – 14.000 dosis
            </li>
            <li class="description list-block">
              Vaksinasi dosis ke 2 bersama Dewan Pers  di MNC Center (28-31 Jul) – 1.622 dosis
            </li>
            <li class="description list-block">
              Vaksinasi dosis ke 2 MVN di Kedoya, Jakarta Barat (3-6 Agustus) – 2.265 dosis
            </li>
            <li class="description list-block">
              Vaksin bersama YEMI (9-10 Agustus) – 900 dosis
            </li>
            <li class="description list-block">
              Vaksin dosis ke-2 Bersama Kemeparekraf di MNC Center, Jakarta Pusat (23-27 Agustus) – 2.639 dosis
            </li>
            <li class="description list-block">
              Vaksinasi dosis ke-2 Bersama Kemenparekraf di MNC Studios, Jakbar (27-31 Agustus) – 3.175 dosis
            </li>
            <li class="description list-block">
              Vaksinasi bersama TNI AL di Pondok Pesantren Al-Qur'an, Yogyakarta (2 September) 1000 dosis
            </li>
            <li class="description list-block">
              Vaksinasi bersama TNI AL di Jogotirto, Sleman (6 September) – 1000 dosis
            </li>
            <li class="description list-block">
              Vaksin di Lido, Kabupaten Bogor (6 September) – 450 dosis
            </li>
            <li class="description list-block">
              Vaksin bersama TNI AL di SMA Budaya Wacana, Terban, Kec. Gondokusuman, Yogyakarta (8 September) – 1000 dosis
            </li>
            <li class="description list-block">
              Vaksin bersama TNI AL di Mako Lanal Yogyakarta (14 September) – 480 dosis
            </li>
            <li class="description list-block">
              Vaksin di Desa Malasari, Kab. Bogor bersama Miss Indonesia (15 September) – 700 dosis
            </li>
            <li class="description list-block">
              Vaksin di MNC Center, Kb. Sirih (20-23 September) – 1.099 dosis
            </li>
            <li class="description list-block">
              Vaksin bersama TNI AL di SMA BIAS Kota Yogyakarta (21 September) – 500 dosis
            </li>
            <li class="description list-block">
              VaKsin di Desa Cipanas Kerjsama Desa Cipanas, Kecamatan Cianjur, Jawa Barat (22 September) 500 dosis
            </li>
            <li class="description list-block">
              Vaksin bersama TNI AL di SMKN 1 Sanden, Bantul, Yogyakarta (23 September) – 1000 dosis
            </li>
            <li class="description list-block">
              Vaksin bersama Dinkes Kota Semarang dan RS Telogorejo, Semarang (23 – 24 September) 1400 dosis
            </li>
            <li class="description list-block">
              Vaksin bersama Ditlantas Polres di Desa Krobokan - Boyolali, Jawa Tengah (24 September) 200 dosis
            </li>
            <br>
            <div class="font-title mg-reset-35">
              Rencana Vaksinasi Kedepan:  
            </div>
            <br>
            <li class="description list-block">
              Sentra Vaksinasi di MNC Center ke 2, Kebon Sirih, Jakarta (11-14 Oktober 2021) (Target 1.100 dosis)
            </li>
            <li class="description list-block">
              Vaksin Bersama Desa Cipanas 2, Cianjur, Jawa Barat (11 Oktober 2021) (Target 500 dosis)
            </li>
            <li class="description list-block">
              Vaksin Bersama Lotte Mart Dosis 1 di Kota Bandung (18 Oktober 2021) (Target 500 dosis)
            </li>
            <li class="description list-block">
              Vaksin Dosis 2 di Desa Malasari, Kabupaten Bogor (21 – 22 Oktober 2021) (Target 500 dosis)
            </li>
            <li class="description list-block">
              Sentra Bersama Lotte Mart Dosis 2  di Kota Bandung (15 November 2021) (Target 500 dosis)
            </li>
          </ol>
        </div>

        <!-- <div class="grid grid--three details">
          <div>
            <img src="https://images.unsplash.com/photo-1579227114347-15d08fc37cae?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=1170&q=80" alt="">
          </div>
          <div>
            <img src="https://images.unsplash.com/photo-1553729459-efe14ef6055d?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=1170&q=80" alt="">
          </div>
          <div>
            <img src="https://images.unsplash.com/photo-1518183214770-9cffbec72538?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2070&q=80" alt="">
          </div>
        </div> -->

        <div class="register details">
          <button>
            <a target="_blank" href="https://mncpeduli.org/">
              Visit MNC Peduli Website
            </a>
          </button>
        </div>

      </div>
    </section>
  </main>
</template>

<script>
import parallax from '@/commons/parallax.js'

export default {
  name: 'DetailCsr',
   methods: {
    parallax(e) {
      const elem = document.querySelector("#parallax > video")

      elem.style.top = parallax.parallaxAnimation(e).vidY;
      elem.style.left = parallax.parallaxAnimation(e).vidX;
    
    }
  }
}
</script>